import air from 'assets/img/air.jpg'
import bowser from 'bowser'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import Tree from 'react-d3-tree'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { getSubTaskTree, getTaskTree } from 'service/TaskService'
import { setTaskTree } from 'store/slices/TaskSlice'
import { useCenteredTree } from './CenteredTree.js'
import styles from './TaskTree.module.scss'
import './custom-tree.css'
import { Button } from 'components/index.js'
const containerStyles = {
  width: '100vw',
  height: '100vh',
  background:'#E8E8EF',
}


export default function TaskTree() {
  const { t } = useTranslation()
  const [data, setData] = useState({})
  const [translate, containerRef] = useCenteredTree()
  const nodeSize = { x: 300, y: 250 }
  const separation = { siblings: 2, nonSiblings: 2 }
  const foreignObjectProps = {
    width: nodeSize.x,
    height: nodeSize.y,
    x: -125,
    y: -55,
  }
  const dispatch = useDispatch()
  const { id } = useParams()
  const navigate = useNavigate()
  const location = useLocation()
  const isSubtasks = location.state?.isSubtasks

  const getData = async (id) => {
    try {
      if (isSubtasks) {
        let response = await getSubTaskTree(id, data)
        dispatch(
          setTaskTree({
            task_tree: response.data,
          }),
        )
        setData(response.data)
      } else {
        let response = await getTaskTree(id, data)
        dispatch(
          setTaskTree({
            task_tree: response.data,
          }),
        )

        setData(response.data)
      }
    } catch (error) {
    }
  }
  const treeData = useSelector((state) => state?.task?.task_tree)
  useEffect(() => {
    if (location.state && location.state.usedId) {
      const usedId = location.state.usedId;
      getData(usedId);
      const button = document.querySelector('foreignObject button');
      const firstParagraph = button.querySelector('p:first-of-type');
      firstParagraph.style.display = 'none';
    } else {
     
      navigate("/home");
    }
  }, [location.pathname]);
  const isSafari =
    bowser.getParser(window.navigator.userAgent).getBrowserName() === 'Safari'

  useEffect(() => {
    if (!isSafari) {
      const button = document?.querySelector('foreignObject button')
      const firstParagraph = button?.querySelector('p:first-of-type')
      firstParagraph.style.display = 'none'
    }
  }, [])

  const buttonStyle = {
    background: 'rgb(169 4 4)',
    border: 'none',
    color: 'white',
    textTransform: 'none',
    fontWeight: 'bold',
    fontFamily: '"Inter", sans-serif',
    fontSize: '14px',
    borderRadius: '6px',
    transition: '0.3s',
    marginTop: '15px',
    marginLeft: '15px',
    '&:hover': {
      background: '#d1f071',
    },
  }

  return (
    <div style={containerStyles} ref={containerRef}>
      <Button onClick={() => navigate(-1)} style={buttonStyle}>
        {' '}
        {t('hooks.taskTree.back')}{' '}
      </Button>
      <Tree
        data={data ?? []}
        translate={translate}
        nodeSize={nodeSize}
        separation={separation}
        transitionDuration="1000"
        pathFunc="step"
        rootNodeClassName="node__root"
        branchNodeClassName="node__branch"
        leafNodeClassName="node__leaf"
        renderCustomNodeElement={(rd3tProps) => {
          if (
            navigator.userAgent.includes('Safari') &&
            !navigator.userAgent.includes('Chrome')
          ) {
            return renderNode({
              ...rd3tProps,
              foreignObjectProps,

              navigate,
              id,
              t,
            })
          } else {
            return renderForeignObjectNode({
              ...rd3tProps,
              foreignObjectProps,

              navigate,
              id,
              t,
            })
          }
        }}
        orientation="vertical"
      />
    </div>
  )
}
const renderNode = ({ nodeDatum, toggleNode, navigate, id, t }) => {
  return (
    <g
      transform={`translate(${nodeDatum.x},${nodeDatum.y})`}
      style={{ fontWeight: '100' }}
    >
      <rect
        x={-165}
        y={-45}
        width={330}
        height={120}
        fill="white"
        cursor="pointer"
        rx={15}
        ry={15}
        stroke="none"
        onClick={toggleNode}
      />
      {nodeDatum.id === parseInt(id) ? (
        ''
      ) : (
        <text
          x={110}
          y={-20}
          textAnchor="middle"
          style={{ fontSize: '14px', fill: 'green' }}
          onClick={() => navigate(`/subtask/`, { state: { usedId: nodeDatum.id } }) }
        >
          {t('hooks.taskTree.open')}
        </text>
      )}

      <text
        x={0}
        y={0}
        textAnchor="middle"
        style={{ fontSize: '12px', fontWeight: 'normal' }}
      >
        {nodeDatum.name}
      </text>
      <text
        x={0}
        y={20}
        textAnchor="middle"
        style={{ fontSize: '12px', fontWeight: 'normal' }}
      >
        {nodeDatum.attributes?.instructor}
      </text>
      <text
        x={0}
        y={40}
        textAnchor="middle"
        style={{ fontSize: '12px', fontWeight: 'normal' }}
      >
        {t('hooks.taskTree.statusLabel')}: {nodeDatum.attributes?.status}
      </text>
    </g>
  )
}
const renderForeignObjectNode = ({
  nodeDatum,
  toggleNode,
  foreignObjectProps,
  classes,
  navigate,
  t,
}) => {
  return (
    <>
      <foreignObject {...foreignObjectProps}>
        <Button
          className={styles.button}
          variant="contained"
          onClick={toggleNode}
        >
          <p
            className={styles.open}
            onClick={() => navigate(`/subtask/`, { state: { usedId: nodeDatum.id } }) }
          >
            {t('hooks.taskTree.open')}
          </p>
          <div className={styles.name}>{nodeDatum?.name}</div>
          <div className={styles.name_emp}>
            {nodeDatum?.attributes?.instructor}
          </div>
          {nodeDatum?.attributes?.status === 'Завершена' ? (
            <div className={styles.statusTextCompleted}>
              {t('hooks.taskTree.statusLabel')}: {nodeDatum?.attributes?.status}
            </div>
          ) : nodeDatum?.attributes?.status === 'В процессе выполнения' ? (
            <div className={styles.statusTextPending}>
              {t('hooks.taskTree.statusLabel')}: {nodeDatum?.attributes?.status}
            </div>
          ) : (
            <div className={styles.statusText}>
              {t('hooks.taskTree.statusLabel')}: {nodeDatum?.attributes?.status}
            </div>
          )}
        </Button>
      </foreignObject>
    </>
  )
}
